import { Group, Title, Button, Text, Tabs, TextInput, Select } from '@mantine/core';
import React, { useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import useGetBonus from './useGetBonusList';
import LoadingErrorContainer from '../../../../components/placeholders/LoadingErrorContainer';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { IconDiamondFilled, IconDiamonds, IconGridDots, IconSearch } from '@tabler/icons-react';
import { Navigate, useNavigate } from 'react-router-dom';
import useGenerateBonus from './useGenerateBonus';
import ActionCell from './components/ActionCell';
import useGetTypeOfMonth from '../typesOfMonths/useGetTypeOfMonths'
import { useQueryClient } from '@tanstack/react-query';
import Row from './components/Row';

dayjs.extend(utc);
dayjs.extend(timezone);


const Remote = () => {

    const { TypeOfMonthListQuery: {
        data: MonthsData },

    } = useGetTypeOfMonth();

    const [type, setType] = useState('everyone');


    const { bonusQuery: {
        data, isPending, isError, isRefetching },
        totalRows,
        handleChangePerPage,
        handlePageChange,
        search,
        setSearch,
        queryKey,
        typeOfMonth,
        setTypeOfMonth
    } = useGetBonus()


    const columns = useMemo(() => {
        let target = [

            {
                name: <Text size='xs' fw={"bold"} >Tiktok Username</Text>,
                selector: row => row.username,
                key: "username",
                //sortable: true,

            },

            {
                name: <Text size='xs' fw={"bold"} >Step Bonus Creator</Text>,
                selector: row => row?.beginner_bonus?.bonus_creator ? <p>{row?.beginner_bonus?.bonus_creator}
                    {row?.beginner_bonus?.bonus_creator_currency == 'diamonds' ? <IconDiamondFilled size={15} color="#238be7" /> : row?.beginner_bonus?.bonus_creator_currency}</p> : 'N/A',
                key: "stepBonusCreator",
                //sortable: true,

            },

            {
                name: <Text size='xs' fw={"bold"} >Step Bonus Agent</Text>,
                selector: row => row?.beginner_bonus?.bonus_agent ? <p>{row?.beginner_bonus?.bonus_agent}  ({row?.beginner_bonus?.bonus_agent_currency == 'diamonds' ? <IconDiamondFilled size={15} color="#238be7" /> : row?.beginner_bonus?.bonus_agent_currency}) </p> : 'N/A',
                key: "stepBonusAgent",
                //sortable: true,

            },

            {
                name: <Text size='xs' fw={"bold"} >Step Bonus Manager</Text>,
                selector: row => row?.beginner_bonus?.bonus_manager ? <p>{row?.beginner_bonus?.bonus_manager}  ({row?.beginner_bonus?.bonus_manager_currency == 'diamonds' ? <IconDiamondFilled size={15} color="#238be7" /> : row?.beginner_bonus?.bonus_manager_currency}) </p> : 'N/A',
                key: "stepBonusManager",
                //sortable: true,

            },

            {
                name: <Text size='xs' fw={"bold"} >Level Bonus Creator</Text>,
                selector: row => row?.advanced_bonus?.bonus_creator ? <p> {row?.advanced_bonus?.bonus_creator}  <IconDiamondFilled size={15} color="#238be7" /> </p> : 'N/A',
                key: "levelBonusCreator",
                //sortable: true,

            },

            {
                name: <Text size='xs' fw={"bold"} >Level Bonus Agent</Text>,
                selector: row => row?.advanced_bonus?.bonus_agent ? <p> {row?.advanced_bonus?.bonus_agent}  <IconDiamondFilled size={15} color="#238be7" /> </p> : 'N/A',
                key: "levelBonusAgent",
                //sortable: true,

            },

            {
                name: <Text size='xs' fw={"bold"} >Level Bonus Manager</Text>,
                selector: row => row?.advanced_bonus?.bonus_manager ? <p> {row?.advanced_bonus?.bonus_manager}  <IconDiamondFilled size={15} color="#238be7" /> </p> : 'N/A',
                key: "levelBonusManager",
                //sortable: true,


            },

            {
                name: <Text size='xs' fw={"bold"} >Total Creator</Text>,
                selector: row => row?.beginner_bonus?.bonus_creator_currency == 'diamonds' ? <p> {row?.beginner_bonus?.bonus_creator + row?.advanced_bonus?.bonus_creator}  <IconDiamondFilled size={15} color="#238be7" /></p> :
                    <p> <p> {row?.advanced_bonus?.bonus_creator}  <IconDiamondFilled size={15} color="#238be7" /> </p>
                        <p>{row?.beginner_bonus?.bonus_creator ? row?.beginner_bonus?.bonus_creator + ' ' + row?.beginner_bonus?.bonus_creator_currency : ""}</p></p>,
                key: "totalCreator",
                //sortable: true,

            },

            {
                name: <Text size='xs' fw={"bold"} >Total Agents</Text>,
                selector: row => row?.beginner_bonus?.bonus_agent_currency == 'diamonds' ? <p> {row?.beginner_bonus?.bonus_agent + row?.advanced_bonus?.bonus_agent}  <IconDiamondFilled size={15} color="#238be7" /></p> :
                    <p> <p> {row?.advanced_bonus?.bonus_agent}  <IconDiamondFilled size={15} color="#238be7" /> </p>
                        <p>{row?.beginner_bonus?.bonus_agent ? row?.beginner_bonus?.bonus_agent + ' ' + row?.beginner_bonus?.bonus_agent_currency : ""}</p></p>,
                key: "totalAgent",
                //sortable: true,

            },

            {
                name: <Text size='xs' fw={"bold"} >Total Manager</Text>,
                // selector: row => row?.beginner_bonus?.bonus_manager_currency == 'diamonds' ? (row?.beginner_bonus?.bonus_manager + row?.advanced_bonus?.bonus_manager > 0) ? <p> {row?.beginner_bonus?.bonus_manager + row?.advanced_bonus?.bonus_manager}  <IconDiamondFilled size={15} color="#238be7" /></p> : 'N/A' :
                //     <p> (row?.advanced_bonus?.bonus_manager > 0) ?  <p> {row?.advanced_bonus?.bonus_manager}  <IconDiamondFilled size={15} color="#238be7" /> </p>
                //         <p>{row?.beginner_bonus?.bonus_manager ? row?.beginner_bonus?.bonus_manager + ' ' + row?.beginner_bonus?.bonus_manager_currency : ""}</p></p>,
                selector: row => Row(row?.beginner_bonus?.bonus_manager_currency, row?.advanced_bonus?.bonus_manager, row?.beginner_bonus?.bonus_manager),

                //sortable: true,
                key: "totalManager",

            },
            {
                name: <Text size='xs' fw={"bold"} >Action</Text>,
                cell: row => <ActionCell row={row} queryKey={queryKey} />,


                key: "action",
            },

        ];

        if (type === "manager") {
            target = target.filter(item => type === "manager" && ["username", "totalManager", "stepBonusManager", "levelBonusManager", 'action'].includes(item.key));
        }
        if (type === "agent") {
            target = target.filter(item => type === "agent" && ["username", "stepBonusAgent", "totalAgent", "levelBonusAgent", 'action'].includes(item.key));
        }
        if (type === "creator") {
            target = target.filter(item => type === "creator" && ["username", "stepBonusCreator", "totalCreator", "levelBonusCreator", 'action'].includes(item.key));
        }
        if (type === "everyone") {
            target = target.filter(item => type === "everyone" && ["username", "stepBonusCreator", "totalCreator", "totalAgent", "totalManager", "levelBonusCreator", "stepBonusAgent", "levelBonusAgent", "stepBonusManager", "levelBonusManager", 'action'].includes(item.key));
        }
        return target
    }, [type]);

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/agency/bonus');
    };

    const performanceHandleClick = () => {
        navigate('/agency/performance');
    };



    const {
        createMutation
    } = useGenerateBonus(queryKey)
    const handleGenerateBonus = () => {
        createMutation.mutate();
    }

    return (
        <LoadingErrorContainer isError={isError} isLoading={isPending} isRefetching={isRefetching}>
            <Group justify=''>
                <Title order={3}>Bonuses</Title>
                <Button
                    variant="gradient" onClick={handleClick}
                    gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                >Create or update <br></br>bonus plans</Button>
                <Button
                    variant="gradient" onClick={performanceHandleClick}
                    gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                >Upload <br></br>Data</Button>
                <Button
                    variant="gradient" onClick={handleGenerateBonus}
                    gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                >Generate <br></br> Bonuses</Button>
                <Button
                    variant="gradient"
                    gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                >Update eligible <br></br> creators</Button>
                <TextInput type='search' defaultValue={search} onChange={(event) => setSearch(event?.target?.value)} placeholder='Search' leftSection={<IconSearch size={18} />} style={{ alignSelf: "flex-end" }} />
            </Group>
            <br></br>
            <Group>
                <Text fw={"bold"}> Display bonuses For:</Text>
                <Tabs defaultValue="everyone"
                    onChange={setType}
                >


                    <Tabs.List
                    >
                        <Tabs.Tab value="everyone">Everyone</Tabs.Tab>
                        <Tabs.Tab value="creator">Creators</Tabs.Tab>
                        <Tabs.Tab value="agent">Agents</Tabs.Tab>
                        <Tabs.Tab value="manager">Managers</Tabs.Tab>
                    </Tabs.List>
                </Tabs>


                <Select
                    label="Select Type of Month"
                    placeholder="Pick one"
                    searchable
                    value={typeOfMonth}
                    data={MonthsData}
                    onChange={setTypeOfMonth}
                    clearable

                    style={{ alignSelf: "flex-end" }}


                />

            </Group>
            <br></br>
            <DataTable
                columns={columns}
                data={data?.data ?? []}
                progressPending={isPending}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handleChangePerPage}
                onChangePage={handlePageChange}



            // selectableRows

            />
            <Group>
                <Button
                    variant="gradient" onClick={handleClick}
                    gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                >Save Final List</Button>
                <Button
                    variant="gradient" onClick={performanceHandleClick}
                    gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                >Final List</Button>
            </Group>

        </LoadingErrorContainer>


    );

}

export default Remote;
